// extracted by mini-css-extract-plugin
export default {"modal_index":"PollAdminOptions_modal_index__qPGWj","container":"PollAdminOptions_container__Yzq-T","admin_button":"PollAdminOptions_admin_button__lPAsN"};